(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    #abort;
    #timer = 0;
    /* Held while a message is being edited in the theme editor. */
    #editing = false;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.querySelector('[data-announcement-close]')?.addEventListener('click', () => this.#close(), { signal });
      const messages = this.#messages();
      if (messages.length < 2) return;

      for (const arrow of this.querySelectorAll('[data-step]')) {
        arrow.hidden = false;
        arrow.addEventListener(
          'click',
          () => {
            this.#stop();
            this.#step(Number(arrow.dataset.step));
          },
          { signal },
        );
      }

      // A message chosen in the theme editor is shown while it is being edited.
      document.addEventListener(
        'shopify:block:select',
        (event) => {
          const index = messages.indexOf(event.target);
          if (index === -1) return;
          this.#editing = true;
          this.#show(index);
        },
        { signal },
      );
      document.addEventListener('shopify:block:deselect', () => (this.#editing = false), { signal });

      if (!this.dataset.autoplay || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Once a visitor reaches into the bar, it is theirs: rotation would move the message they are reading.
      this.addEventListener('focusin', () => this.#stop(), { signal });
      this.#timer = setInterval(() => {
        if (this.#editing || document.hidden || this.matches(':hover')) return;
        this.#step(1);
      }, Number(this.dataset.autoplay));
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.#stop();
    }

    /* Closed for good on this device, until the messages change (their fingerprint is remembered). */
    #close() {
      try {
        localStorage.setItem('cottolio:announcement-closed', this.dataset.dismissible);
      } catch (error) {
        // Storage blocked: closed for this page only.
      }
      this.#stop();
      this.hidden = true;
      // The header's own observer follows the bar's height too; this covers the moment in between.
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      // The button is gone with the bar: focus moves to the start of the header rather than the page
      // (its first control that shows at this width: the menu button is hidden on desktop).
      [...document.querySelectorAll('.section-header a[href], .section-header button')]
        .find((control) => control.checkVisibility?.() ?? control.offsetParent !== null)
        ?.focus({ preventScroll: true });
    }

    /* Rotation over for this visit; from here each step is the visitor's own, so it is read out. */
    #stop() {
      clearInterval(this.#timer);
      this.#timer = 0;
      this.querySelector('.announcement-bar__messages')?.setAttribute('aria-live', 'polite');
    }

    #messages() {
      return [...this.querySelectorAll('.announcement-bar__message')];
    }

    #step(direction) {
      const messages = this.#messages();
      const current = messages.findIndex((message) => message.hasAttribute('data-active'));
      this.#show((current + direction + messages.length) % messages.length);
    }

    #show(index) {
      this.#messages().forEach((message, position) => {
        message.toggleAttribute('data-active', position === index);
        message.inert = position !== index;
      });
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  /*
    Builds the contents list from the body's headings, giving each one an id to link to, and
    marks the heading the reader has reached. Targets are looked up on every pass, so a section
    the theme editor re-renders (or removes) is picked up.
  */
  class ArticleToc extends HTMLElement {
    #abort;
    #frame = 0;
    #links = [];

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      this.#build();
      // One heading is not a table of contents; the list stays hidden.
      if (this.#links.length < 2) return;
      this.querySelector('nav').hidden = false;

      window.addEventListener('scroll', () => this.#schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.#schedule(), { signal });
      this.addEventListener(
        'click',
        (event) => {
          // A link the reader just clicked leads; the scroll that follows confirms it.
          const link = event.target.closest('[data-target]');
          if (link) this.#mark(link);
        },
        { signal },
      );
      this.#update();
    }

    disconnectedCallback() {
      this.#abort.abort();
      cancelAnimationFrame(this.#frame);
      this.#frame = 0;
    }

    #build() {
      const body = document.querySelector('[data-article-body]');
      const list = this.querySelector('[data-list]');
      if (!body || !list) return;

      // The theme editor moves a section rather than replacing it, so this can run again.
      this.#links = [];
      list.replaceChildren();

      // A heading with no text (an image, say) is nothing to link to and gets no id.
      const items = [...body.querySelectorAll('h2')]
        .filter((heading) => heading.textContent.trim())
        .map((heading) => ({ id: this.#idFor(heading), label: heading.textContent.trim() }));

      const { extraAnchor, extraLabel } = this.dataset;
      if (extraAnchor && extraLabel) items.push({ id: extraAnchor, label: extraLabel });

      for (const item of items) {
        if (!item.id || !item.label) continue;
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'article-toc__link';
        link.href = `#${item.id}`;
        link.dataset.target = item.id;
        link.textContent = item.label;
        listItem.append(link);
        list.append(listItem);
        this.#links.push(link);
      }
    }

    /* Keeps an id the writer set; otherwise makes one from the heading, kept unique. */
    #idFor(heading) {
      if (heading.id) return heading.id;
      const text = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, '-');
      const base = `section-${text}`.slice(0, 60);
      let id = base;
      for (let index = 2; document.getElementById(id); index += 1) id = `${base}-${index}`;
      heading.id = id;
      return id;
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    }

    #update() {
      // The offset anchor jumps use, so a heading jumped to counts as reached.
      const offset = Number.parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;

      const shown = [];
      for (const link of this.#links) {
        const target = document.getElementById(link.dataset.target);
        link.parentElement.hidden = !target;
        if (target) shown.push({ link, target });
      }
      this.querySelector('nav').hidden = shown.length < 2;
      if (!shown.length) return;

      let current = shown[0];
      for (const entry of shown) {
        if (entry.target.getBoundingClientRect().top <= offset + 8) current = entry;
      }
      // At the end of the page no further heading can reach the line, so the last one is current.
      const atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atEnd) current = shown.at(-1);
      this.#mark(current.link);
    }

    #mark(link) {
      if (link.getAttribute('aria-current') === 'true') return;
      for (const other of this.#links) other.setAttribute('aria-current', String(other === link));
    }
  }

  customElements.define('article-toc', ArticleToc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    #abort = new AbortController();
    #noteTimer;
    #busy = false;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.dialog = this.querySelector('[data-cart-dialog]');

      document.addEventListener(
        'click',
        (event) => {
          const toggle = event.target.closest('[data-cart-drawer-toggle]');
          // Modified clicks still open /cart in a new tab or window.
          const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
          if (!toggle || modified) return;
          event.preventDefault();
          this.open();
        },
        { signal },
      );

      // Every add-to-cart form on the page (quick buy, product page) goes through the drawer,
      // unless another script has already cancelled the submission, or the button submits
      // straight to checkout (Buy now, marked data-skip-drawer).
      document.addEventListener(
        'submit',
        (event) => {
          const form = event.target;
          if (event.defaultPrevented || !(form instanceof HTMLFormElement)) return;
          if (event.submitter?.hasAttribute('data-skip-drawer')) return;
          if (!new URL(form.action).pathname.endsWith('/cart/add')) return;
          event.preventDefault();
          this.#add(form, event.submitter);
        },
        { signal },
      );

      // Backdrop, Escape, the close button and aria-expanded on close: snippets/modal-dialog.liquid.
      this.dialog.addEventListener('click', (event) => this.#onClick(event), { signal });
      this.dialog.addEventListener('change', (event) => this.#onChange(event), { signal });
      this.dialog.addEventListener('input', (event) => this.#onInput(event), { signal });
      this.dialog.addEventListener('submit', (event) => this.#onSubmit(event), { signal });
      // Every way of closing ends here, a back gesture included, so the note is never lost.
      this.dialog.addEventListener('close', () => this.#saveNote({ keepalive: true }), { signal });
      // Back or forward can restore this page from memory with the cart as it was then (say, before
      // a line was removed on /cart); fetch it as it is now, which also puts the header count right.
      window.addEventListener('pageshow', (event) => event.persisted && this.#refresh(), { signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
      clearTimeout(this.#noteTimer);
    }

    get content() {
      return this.querySelector('[data-cart-content]');
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      document
        .querySelectorAll('[data-cart-drawer-toggle]')
        .forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
    }

    #onClick(event) {
      const tool = event.target.closest('[data-cart-tool]');
      if (tool) {
        this.#togglePanel(tool.getAttribute('aria-controls'));
        return;
      }

      const quantityButton = event.target.closest('[data-quantity]');
      if (quantityButton) {
        const key = quantityButton.closest('[data-key]').dataset.key;
        this.#update('cart/change.js', { id: key, quantity: Number(quantityButton.dataset.quantity) });
        return;
      }

      if (event.target.closest('[data-coupon-remove]')) {
        this.#update('cart/update.js', { attributes: { discount_code: '' } });
      }
    }

    #onChange(event) {
      if (event.target.closest('[data-cart-note]')) {
        // Leaving the field (e.g. for Check out) saves at once; keepalive lets it outlive the page.
        this.#saveNote({ keepalive: true });
        return;
      }

      const input = event.target.closest('[data-quantity-input]');
      if (!input) return;
      const quantity = Number.parseInt(input.value, 10);
      // An emptied or non-numeric field puts the quantity back rather than removing the line.
      if (Number.isNaN(quantity) || quantity < 0) {
        input.value = input.defaultValue;
        return;
      }
      this.#update('cart/change.js', { id: input.closest('[data-key]').dataset.key, quantity }).then((ok) => {
        if (!ok && input.isConnected) input.value = input.defaultValue;
      });
    }

    /* The note saves on its own after a pause in typing, without re-rendering under the cursor. */
    #onInput(event) {
      if (!event.target.closest('[data-cart-note]')) return;
      clearTimeout(this.#noteTimer);
      this.#noteTimer = setTimeout(() => this.#saveNote(), 600);
    }

    /* Coupon: format check only; checkout decides whether the code is valid (plan §8 decision 1). */
    #onSubmit(event) {
      const form = event.target.closest('[data-coupon-form]');
      if (!form) return;
      event.preventDefault();
      const input = form.elements.code;
      const code = input.value.trim();
      const valid = /^[A-Za-z0-9_-]{1,64}$/.test(code);
      input.setAttribute('aria-invalid', String(!valid));
      this.content.querySelector('[data-coupon-error]').hidden = valid;
      if (valid) this.#update('cart/update.js', { attributes: { discount_code: code.toUpperCase() } });
    }

    #togglePanel(id) {
      for (const tool of this.content.querySelectorAll('[data-cart-tool]')) {
        const open = tool.getAttribute('aria-controls') === id && tool.getAttribute('aria-expanded') !== 'true';
        tool.setAttribute('aria-expanded', String(open));
        this.content.querySelector(`#${tool.getAttribute('aria-controls')}`).hidden = !open;
      }
    }

    /* Saves the note if it differs from what the server last rendered. Returns once it's stored. */
    async #saveNote({ keepalive = false } = {}) {
      clearTimeout(this.#noteTimer);
      const note = this.content?.querySelector('[data-cart-note]');
      if (!note || note.value === note.defaultValue) return;
      const status = this.content.querySelector('[data-note-status]');
      try {
        await this.#post('cart/update.js', { note: note.value }, { keepalive });
        note.defaultValue = note.value;
        if (status?.isConnected) status.textContent = note.dataset.saved ?? '';
      } catch (error) {
        if (status?.isConnected) status.textContent = error.message;
      }
    }

    async #add(form, submitter) {
      submitter?.setAttribute('aria-busy', 'true');
      submitter?.toggleAttribute('disabled', true);
      try {
        await this.#saveNote();
        const body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);
        const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
        this.#render(data.sections);
        this.open();
      } catch (error) {
        this.open();
        this.#showError(error.message);
      } finally {
        submitter?.removeAttribute('aria-busy');
        // data-unavailable: the page disabled it meanwhile (e.g. a sold-out variant was chosen).
        submitter?.toggleAttribute('disabled', submitter.hasAttribute('data-unavailable'));
      }
    }

    /*
      One change at a time: while a request is out, further clicks and keypresses are ignored,
      so quantities are always computed from what's on screen and responses can't arrive out of
      order. Resolves to whether the change went through.
    */
    async #update(url, body) {
      if (this.#busy) return false;
      this.#busy = true;
      this.content.setAttribute('aria-busy', 'true');
      try {
        await this.#saveNote();
        const data = await this.#post(url, {
          ...body,
          sections: 'cart-drawer',
          sections_url: window.location.pathname,
        });
        this.#render(data.sections);
        return true;
      } catch (error) {
        this.#showError(error.message);
        return false;
      } finally {
        this.#busy = false;
        this.content.removeAttribute('aria-busy');
      }
    }

    async #post(url, body, { keepalive = false } = {}) {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}${url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
        keepalive,
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || this.dataset.error);
      return data;
    }

    /*
      Swap in the freshly rendered contents. The open panel, a note still being typed and the
      focused control carry over; when that control is gone (a removed line) focus goes to the title.
    */
    async #refresh() {
      try {
        const root = window.Shopify?.routes?.root ?? '/';
        const response = await fetch(`${root}?sections=cart-drawer`);
        if (response.ok) this.#render(await response.json());
      } catch {
        // Offline or blocked: the restored page stays as it was, and the next change corrects it.
      }
    }

    #render(sections) {
      const html = sections?.['cart-drawer'];
      const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
      if (!next) return;

      const current = this.content;
      const openPanel = current.querySelector('[data-cart-tool][aria-expanded="true"]')?.getAttribute('aria-controls');
      const focusKey = current.contains(document.activeElement)
        ? (document.activeElement.closest('[data-focus]')?.dataset.focus ?? 'title')
        : null;
      const note = current.querySelector('[data-cart-note]');

      current.replaceWith(next);
      if (openPanel) this.#togglePanel(openPanel);
      const nextNote = next.querySelector('[data-cart-note]');
      if (note && nextNote && note.value !== nextNote.value) nextNote.value = note.value;
      if (focusKey) {
        const target = [...next.querySelectorAll('[data-focus]')].find((element) => element.dataset.focus === focusKey);
        (target ?? next.querySelector('[data-focus="title"]'))?.focus();
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: { count: Number(next.dataset.itemCount), label: next.dataset.countLabel },
        }),
      );
    }

    #showError(message) {
      const error = this.content.querySelector('[data-cart-error]');
      error.textContent = message || this.dataset.error;
      error.hidden = false;
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /*
    Progressive enhancement: the forms in the page post to Shopify's cart routes on their own,
    and this intercepts them so a change re-renders the section (and the drawer's count) in place.
  */
  class CartPage extends HTMLElement {
    #abort;
    #busy = false;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.addEventListener('submit', (event) => this.#onSubmit(event), { signal });
      this.addEventListener('change', (event) => this.#onQuantityChange(event), { signal });
      // Back or forward can restore /cart from memory with old lines; show the cart as it is now.
      window.addEventListener('pageshow', (event) => event.persisted && this.#refresh(), { signal });
    }

    async #refresh() {
      try {
        const ids = [this.#sectionId(), this.#headerId()].filter(Boolean).join(',');
        // No JSON Accept header: /cart would answer with the cart itself instead of the sections.
        const response = await fetch(`${window.location.pathname}?sections=${ids}`);
        if (response.ok) this.#render(await response.json());
      } catch {
        // Offline or blocked: the restored page stays as it was, and the next change corrects it.
      }
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    #onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();

      if (form.matches('[data-coupon-form]')) {
        this.#applyCoupon(form);
        return;
      }

      const body = new URLSearchParams(new FormData(form, event.submitter));
      this.#update(form.action, body);
    }

    /* A typed quantity: the browser would need the update button, so send it straight away. */
    #onQuantityChange(event) {
      const input = event.target.closest('[data-line-quantity]');
      if (!input) return;
      const quantity = Math.floor(Number(input.value));
      // An emptied or non-numeric field puts the quantity back rather than removing the line.
      if (input.value.trim() === '' || !Number.isFinite(quantity) || quantity < 0) {
        input.value = input.defaultValue;
        return;
      }
      input.value = quantity;
      const body = new URLSearchParams({ id: input.form.elements.id.value, quantity });
      // A refused change (e.g. more than in stock) leaves the line as it was, so the field follows.
      this.#update(input.form.action, body).then((ok) => {
        if (!ok) input.value = input.defaultValue;
      });
    }

    /* Format only; checkout decides whether the code is real (plan §8 decision 1). */
    #applyCoupon(form) {
      const input = form.elements['attributes[discount_code]'];
      const code = input.value.trim();
      const valid = /^[A-Za-z0-9_-]{1,64}$/.test(code);
      input.setAttribute('aria-invalid', String(!valid));
      this.querySelector('[data-coupon-error]').hidden = valid;
      if (!valid) return;
      this.#update(form.action, new URLSearchParams({ 'attributes[discount_code]': code.toUpperCase() }));
    }

    /* Resolves true once the section shows the new cart, false if the change didn't happen. */
    async #update(url, body) {
      if (this.#busy) return false;
      this.#busy = true;
      const content = this.querySelector('[data-cart-content]');
      content?.setAttribute('aria-busy', 'true');
      body.set('sections', [this.#sectionId(), this.#headerId()].filter(Boolean).join(','));
      body.set('sections_url', window.location.pathname);
      try {
        // The form routes redirect; their .js twins answer with the cart and the sections.
        const response = await fetch(url.replace(/\/cart\/(change|update)$/, '/cart/$1.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
          body,
        });
        // An error page (5xx, gateway) isn't JSON; the generic message covers it.
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.sections) throw new Error(data.description || data.message || '');
        this.#render(data.sections);
        return true;
      } catch (error) {
        const message = this.querySelector('[data-cart-error]');
        // Shopify's own messages are shown; a network failure (TypeError) gets the generic one.
        message.textContent = (!(error instanceof TypeError) && error.message) || message.dataset.error;
        message.hidden = false;
        return false;
      } finally {
        this.#busy = false;
        content?.removeAttribute('aria-busy');
      }
    }

    #sectionId() {
      return this.closest('.shopify-section').id.replace('shopify-section-', '');
    }

    /* The cart page has no drawer, so the header's own markup carries the count. */
    #headerId() {
      return document.querySelector('.section-header')?.id.replace('shopify-section-', '');
    }

    #render(sections) {
      const parser = new DOMParser();
      const fresh = parser.parseFromString(sections[this.#sectionId()] ?? '', 'text/html').querySelector('cart-page');
      // Whatever was in use keeps the focus across the swap, as in the drawer.
      const focusKey = this.contains(document.activeElement)
        ? document.activeElement.closest('[data-focus]')?.dataset.focus
        : null;
      if (fresh) this.replaceChildren(...fresh.childNodes);
      if (focusKey) {
        const target = [...this.querySelectorAll('[data-focus]')].find((element) => element.dataset.focus === focusKey);
        (target ?? this.querySelector('.cart__heading'))?.focus();
      }

      const headerHtml = sections[this.#headerId()];
      if (!headerHtml) return;
      const next = parser.parseFromString(headerHtml, 'text/html');
      const count = next.querySelector('[data-cart-count]');
      if (!count) return;
      // The header listens for this, and so can anything else that tracks the cart.
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            count: Number(count.textContent.trim()),
            label: next.querySelector('[data-cart-label]')?.textContent.trim(),
          },
        }),
      );
    }
  }

  customElements.define('cart-page', CartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* One dropdown open at a time; a click outside it or Escape closes it. */
  class FacetFilters extends HTMLElement {
    #abort = new AbortController();

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.dropdowns = [...this.querySelectorAll('[data-facet]')];

      for (const dropdown of this.dropdowns) {
        dropdown.addEventListener(
          'toggle',
          () => {
            if (!dropdown.open) return;
            for (const other of this.dropdowns) if (other !== dropdown) other.open = false;
          },
          { signal },
        );
      }

      document.addEventListener(
        'click',
        (event) => {
          for (const dropdown of this.dropdowns) if (!dropdown.contains(event.target)) dropdown.open = false;
        },
        { signal },
      );
      // On the document: clicking a summary doesn't focus it in every browser (Safari).
      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape') return;
          const open = this.dropdowns.find((dropdown) => dropdown.open);
          if (!open) return;
          open.open = false;
          open.querySelector('summary').focus();
        },
        { signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
    }
  }

  customElements.define('facet-filters', FacetFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cooking-modes"] && !Shopify.designMode) return;
  try {
    
  /* The tabs themselves are a <tab-list> (snippets/tab-list.liquid); this only warms the images. */
  class CookingModes extends HTMLElement {
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      const bar = this.querySelector('[role="tablist"]');
      for (const event of ['pointerenter', 'focusin', 'touchstart']) {
        bar?.addEventListener(event, () => this.#preload(), { once: true, passive: true, signal });
      }
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    /*
      A lazy image in a hidden panel isn't fetched until its tab is chosen, which leaves an empty
      frame for a moment. Reaching for the tabs is enough intent to fetch the rest, quietly.
    */
    #preload() {
      for (const image of this.querySelectorAll('img[loading="lazy"]')) {
        image.fetchPriority = 'low';
        image.loading = 'eager';
      }
    }
  }

  customElements.define('cooking-modes', CookingModes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /*
    The category tabs are a <tab-list> (snippets/tab-list.liquid); this follows which one is chosen.
    Expand more shows the rest of a category. The search box filters the questions already on the
    page: they are metaobjects, which `/search` does not index, and everything in scope is rendered
    anyway.
  */
  class FaqTabs extends HTMLElement {
    #abort = new AbortController();
    #timer = 0;
    #current = 0;
    /** The FAQ page's mobile anchors: a media query, or null on every other FAQ instance. */
    #mobileAnchors = null;
    #allPanelsVisible = false;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.tabList = this.querySelector('tab-list');
      this.panels = [...this.querySelectorAll('[data-faq-panel]')];
      this.results = this.querySelector('[data-faq-results]');

      const form = this.querySelector('[data-faq-search]');
      if (form) {
        const field = form.querySelector('input');
        form.addEventListener('submit', (event) => event.preventDefault(), { signal });
        form.addEventListener(
          'input',
          () => {
            clearTimeout(this.#timer);
            this.#timer = setTimeout(() => this.#search(field.value), 150);
          },
          { signal },
        );
      }

      this.addEventListener('tab-list:change', (event) => (this.#current = event.detail.index), { signal });

      /*
        Below 1024 the FAQ page swaps the tab bar for the sticky anchor row and lays every category
        out at once. That can't be done in CSS: critical.css keeps `[hidden] { display: none
        !important }` authoritative so a class can never leave a hidden element on screen, and the
        panels arrive from Liquid with the attribute on all but the first. So the attribute is
        dropped here, on the breakpoint, and put back when the tab bar returns.
      */
      if (this.classList.contains('faq--mobile-anchors')) {
        this.#mobileAnchors = window.matchMedia('(max-width: 1023px)');
        this.#mobileAnchors.addEventListener('change', () => this.#syncPanels(), { signal });
        this.addEventListener('click', (event) => this.#followAnchor(event), { signal });
        this.#syncPanels();
      }

      this.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-faq-expand]');
          if (!button) return;
          const panel = button.closest('[data-faq-panel]');
          const more = panel.querySelectorAll('[data-faq-more]');
          more.forEach((item) => (item.hidden = false));
          more[0]?.querySelector('summary')?.focus();
          button.hidden = true;
          // Remembered, so clearing a search puts the panel back the way the reader left it.
          panel.dataset.expanded = 'true';
        },
        { signal },
      );
    }

    /* The anchor row is plain links: the jump is the browser's, this only keeps state in step. */
    #followAnchor(event) {
      const anchor = event.target.closest('.faq__mobile-anchor');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      const index = this.panels.findIndex((panel) => `#${panel.id}` === href);
      if (index === -1) return;
      this.tabList?.select(index, { scroll: false });
      // Tapping the pill that's already in the address bar changes nothing, so the browser
      // doesn't jump; do it here instead.
      if (window.location.hash === href) {
        event.preventDefault();
        this.panels[index].scrollIntoView();
      }
    }

    /** Open every panel while the mobile anchors are in charge; hand them back to the tabs after. */
    #syncPanels() {
      const anchors = this.#mobileAnchors?.matches ?? false;
      // The buttons are read straight from the DOM: this element connects before the <tab-list>
      // inside it is upgraded, so asking that element for its tabs would come back undefined.
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      this.#allPanelsVisible = anchors;
      this.toggleAttribute('data-mobile-anchors', anchors);
      this.tabList?.toggleAttribute('data-panels-always-visible', anchors);

      this.panels.forEach((panel, index) => {
        const tab = tabs[index];
        if (anchors) {
          panel.hidden = false;
          // The tabs are display: none there, so a tabpanel's label would resolve to nothing.
          if (tab) {
            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-label', tab.textContent.trim());
            panel.removeAttribute('aria-labelledby');
          }
          return;
        }
        if (tab) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.removeAttribute('aria-label');
        }
        panel.hidden = index !== this.#current;
      });
    }

    disconnectedCallback() {
      this.#abort.abort();
      clearTimeout(this.#timer);
    }

    /* Every match is shown, whichever category it is in; an empty box puts the page back. */
    #search(value) {
      const terms = value.trim().toLowerCase();
      this.toggleAttribute('data-searching', terms !== '');

      if (terms === '') {
        this.#restore();
        return;
      }

      let total = 0;
      for (const panel of this.panels) {
        let matches = 0;
        for (const item of panel.querySelectorAll('[data-faq-item]')) {
          const hit = item.textContent.toLowerCase().includes(terms);
          item.hidden = !hit;
          if (hit) matches += 1;
        }
        total += matches;
        panel.hidden = matches === 0;
        const more = panel.querySelector('[data-faq-expand]');
        if (more) more.hidden = true;
      }

      if (!this.results) return;
      const template = total === 1 ? this.dataset.resultsOne : this.dataset.resultsOther;
      this.results.textContent = total === 0 ? this.dataset.resultsNone : template.replace('%n%', total);
      this.results.hidden = false;
    }

    #restore() {
      for (const panel of this.panels) {
        const expanded = panel.dataset.expanded === 'true';
        for (const item of panel.querySelectorAll('[data-faq-item]')) {
          item.hidden = item.hasAttribute('data-faq-more') && !expanded;
        }
        const more = panel.querySelector('[data-faq-expand]');
        if (more) more.hidden = expanded;
      }
      // Back to the chosen category; with a single category there are no tabs and its panel shows.
      if (this.tabList) this.tabList.select(this.#current, { scroll: false });
      if (this.#allPanelsVisible || !this.tabList) this.panels.forEach((panel) => (panel.hidden = false));
      if (this.results) this.results.hidden = true;
    }
  }

  customElements.define('faq-tabs', FaqTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-rows"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('feature-row-video')) return;

    /* Loaded once, on demand: a page without a YouTube row never fetches the player API. */
    let youtubeApi;
    const loadYouTubeApi = () => {
      if (window.YT?.Player) return Promise.resolve(window.YT);
      if (youtubeApi) return youtubeApi;
      youtubeApi = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          previous?.();
          resolve(window.YT);
        };
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.addEventListener('error', () => reject(new Error('YouTube API failed')));
        document.head.append(script);
        setTimeout(() => reject(new Error('YouTube API timed out')), 8000);
      });
      return youtubeApi;
    };

    /*
      One row's media. Autoplay is always muted (browsers refuse audible autoplay); any play the
      visitor starts by hand — including rescuing a blocked autoplay — plays at half volume. Only
      the rows on screen play. The button hides while playing and returns on hover, focus or a tap,
      so the moving picture can still be paused (WCAG 2.2.2).
    */
    class FeatureRowVideo extends HTMLElement {
      #abort;
      #observer;
      #control;
      #video;
      #frame;
      #poster;
      #player;
      #ytTimer;
      #ready = false;
      #playing = false;
      #inView = false;
      #loaded = false;
      #userPaused = false;
      #manualSound = false;
      #pendingPlay = false;
      #autoplay = false;
      #reduced = false;
      #youtubeId = '';

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        this.#autoplay = this.dataset.autoplay === 'true';
        this.#reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#youtubeId = this.dataset.youtubeId ?? '';
        this.#control = this.querySelector('[data-control]');
        this.#video = this.querySelector('[data-video]');
        this.#frame = this.querySelector('[data-frame]');
        this.#poster = this.querySelector('[data-poster]');

        this.#control?.addEventListener('click', () => this.#toggle(), { signal });
        this.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-control]')) return;
            this.#toggle();
          },
          { signal },
        );

        // maxres is not available for every upload; hq always is.
        if (this.#youtubeId && this.#poster && !this.#poster.src) {
          this.#poster.addEventListener(
            'error',
            () => {
              this.#poster.src = `https://i.ytimg.com/vi/${this.#youtubeId}/hqdefault.jpg`;
            },
            { signal },
          );
          this.#poster.src = `https://i.ytimg.com/vi/${this.#youtubeId}/maxresdefault.jpg`;
        }

        if (this.#video) {
          this.#video.addEventListener('play', () => this.#setPlaying(true), { signal });
          this.#video.addEventListener('pause', () => this.#setPlaying(false), { signal });
        }

        this.#observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && !this.#loaded) this.#load();
            this.#inView = entry.intersectionRatio >= 0.5;
            this.#sync();
          },
          { threshold: [0, 0.5] },
        );
        this.#observer.observe(this);
        this.#paint();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#observer?.disconnect();
        clearTimeout(this.#ytTimer);
        try {
          this.#player?.destroy();
        } catch {
          // The theme editor may have removed the frame before the player could be destroyed.
        }
      }

      #load() {
        this.#loaded = true;
        if (this.#video) {
          this.#video.preload = 'metadata';
          this.#video.load();
          return;
        }
        this.#loadYouTube();
      }

      async #loadYouTube() {
        if (!this.#frame) return;
        try {
          const api = await loadYouTubeApi();
          if (!this.isConnected || !this.#frame.isConnected) return;
          this.#player = new api.Player(this.#frame, {
            videoId: this.#youtubeId,
            playerVars: {
              autoplay: 0,
              mute: 1,
              controls: 0,
              playsinline: 1,
              loop: 1,
              playlist: this.#youtubeId,
              rel: 0,
              modestbranding: 1,
              origin: window.location.origin,
            },
            events: {
              onReady: (event) => {
                this.#ready = true;
                event.target.setVolume(50);
                event.target.mute();
                this.toggleAttribute('data-player-ready', true);
                if (this.#pendingPlay) {
                  this.#pendingPlay = false;
                  this.#manualSound = true;
                  this.#play(true);
                } else {
                  this.#sync();
                }
              },
              onStateChange: (event) => {
                if (event.data === 1) this.#setPlaying(true);
                if (event.data === 2 || event.data === 0) this.#setPlaying(false);
              },
            },
          });
        } catch {
          this.#youtubeFallback();
        }
      }

      /* If the API cannot load (blocked, offline), native controls still leave a usable player. */
      #youtubeFallback() {
        if (!this.#frame?.isConnected) return;
        const params = new URLSearchParams({
          autoplay: this.#autoplay && !this.#reduced ? '1' : '0',
          mute: '1',
          loop: '1',
          playlist: this.#youtubeId,
          controls: '1',
          playsinline: '1',
          rel: '0',
        });
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${this.#youtubeId}?${params}`;
        iframe.title = this.dataset.title || this.dataset.playLabel || 'Video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.loading = 'lazy';
        // Keep the poster until the frame has actually drawn something.
        iframe.addEventListener('load', () => this.toggleAttribute('data-player-ready', true), {
          once: true,
        });
        this.toggleAttribute('data-native-player', true);
        this.#frame.replaceWith(iframe);
        this.#control?.remove();
      }

      #sync() {
        const shouldPlay = this.#autoplay && !this.#reduced && this.#inView && !this.#userPaused;
        if (shouldPlay) this.#play(this.#manualSound);
        else this.#pause();
      }

      #play(sound) {
        if (this.#video) {
          this.#video.muted = !sound;
          if (sound) this.#video.volume = 0.5;
          this.#video.play().catch(() => this.#setPlaying(false));
          return;
        }
        if (!this.#ready || !this.#player) return;
        // Start muted first: YouTube can drop a playVideo() that asks for sound in the same tick.
        this.#player.mute();
        this.#player.playVideo();
        if (sound) {
          this.#player.unMute();
          this.#player.setVolume(50);
        }
        this.#verifyYouTube();
      }

      /* The API has no play promise; if nothing starts, leave the button offering Play again. */
      #verifyYouTube() {
        clearTimeout(this.#ytTimer);
        this.#ytTimer = setTimeout(() => {
          const state = this.#player?.getPlayerState?.();
          if (state !== 1 && state !== 3) this.#setPlaying(false);
        }, 900);
      }

      #pause() {
        if (this.#video) {
          if (!this.#video.paused) this.#video.pause();
          return;
        }
        if (this.#ready) this.#player?.pauseVideo();
        this.#setPlaying(false);
      }

      #toggle() {
        if (this.#playing) {
          this.#userPaused = true;
          this.#setPlaying(false);
          this.#pause();
          return;
        }
        this.#userPaused = false;
        this.#manualSound = true;
        if (!this.#loaded) this.#load();
        if (this.#youtubeId && !this.#ready) {
          this.#pendingPlay = true;
          return;
        }
        this.#setPlaying(true);
        this.#play(true);
      }

      #setPlaying(playing) {
        if (this.#playing === playing) return;
        this.#playing = playing;
        this.#paint();
      }

      #paint() {
        if (!this.#control) return;
        this.#control.toggleAttribute('data-playing', this.#playing);
        this.#control.setAttribute('aria-label', this.#playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }
    }

    customElements.define('feature-row-video', FeatureRowVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-switcher"] && !Shopify.designMode) return;
  try {
    
  class FeatureAccordion extends HTMLElement {
    #abort;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      this.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-feature-summary]');
          const item = button?.closest('.feature-switcher__accordion-item');
          if (!item || !this.contains(item)) return;
          // One open row at a time: the chosen row toggles, every other row closes.
          const open = item.classList.contains('is-open');
          this.items.forEach((row) => this.#setOpen(row, row === item && !open));
        },
        { signal: this.#abort.signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    get items() {
      return [...this.querySelectorAll('.feature-switcher__accordion-item')];
    }

    #setOpen(item, open) {
      item.classList.toggle('is-open', open);
      const button = item.querySelector('.feature-switcher__accordion-summary');
      const panel = item.querySelector('.feature-switcher__accordion-panel');
      if (button) button.setAttribute('aria-expanded', String(open));
      if (panel) panel.inert = !open;
    }
  }

  customElements.define('feature-accordion', FeatureAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    #closeTimer;
    // The item a mouse just opened by hovering; the click that usually follows keeps it open.
    #hoverOpened = null;
    #abort = new AbortController();

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.header = this.querySelector('.header');
      this.items = [...this.querySelectorAll('[data-menu-item]')];

      for (const item of this.items) {
        const trigger = item.querySelector('[data-menu-trigger]');
        trigger.addEventListener(
          'click',
          () => {
            if (this.#hoverOpened === item) this.#hoverOpened = null;
            else this.#toggle(item);
          },
          { signal },
        );
        item.addEventListener('pointerenter', (event) => this.#hoverOpen(event, item), { signal });
        item.addEventListener('pointerleave', (event) => this.#hoverClose(event, item), { signal });
        item.addEventListener(
          'focusout',
          (event) => {
            if (!item.contains(event.relatedTarget)) this.#close(item);
          },
          { signal },
        );
        item.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape' || !item.hasAttribute('data-open')) return;
            this.#close(item);
            trigger.focus();
          },
          { signal },
        );
      }

      document.addEventListener(
        'click',
        (event) => {
          if (!this.contains(event.target)) this.#closeAll();
        },
        { signal },
      );

      window.addEventListener('scroll', () => this.#syncScrolled(), { passive: true, signal });
      this.#syncScrolled();
      this.#watchAnnouncementBar();
      // The theme editor replaces the bar whenever a message is edited; watch the new one.
      document.addEventListener(
        'shopify:section:load',
        (event) => {
          if (event.target.querySelector?.('.announcement-bar')) this.#watchAnnouncementBar();
        },
        { signal },
      );
      this.#setUpDrawer(signal);

      document.addEventListener('shopify:block:select', (event) => this.#revealBlock(event), { signal });
      document.addEventListener('shopify:block:deselect', () => this.#closeAll(), { signal });
      // The cart drawer announces every change; the count and its label follow.
      document.addEventListener(
        'cart:updated',
        ({ detail }) => {
          const count = this.querySelector('[data-cart-count]');
          const label = this.querySelector('[data-cart-label]');
          if (count) {
            count.textContent = detail.count;
            count.hidden = detail.count === 0;
          }
          if (label) label.textContent = detail.label;
        },
        { signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.resizeObserver?.disconnect();
    }

    #open(item) {
      clearTimeout(this.#closeTimer);
      for (const other of this.items) if (other !== item) this.#close(other);
      item.setAttribute('data-open', '');
      item.querySelector('[data-menu-trigger]').setAttribute('aria-expanded', 'true');
      this.header.setAttribute('data-menu-open', '');
    }

    #close(item) {
      if (this.#hoverOpened === item) this.#hoverOpened = null;
      item.removeAttribute('data-open');
      item.querySelector('[data-menu-trigger]').setAttribute('aria-expanded', 'false');
      if (!this.items.some((other) => other.hasAttribute('data-open'))) this.header.removeAttribute('data-menu-open');
    }

    #closeAll() {
      for (const item of this.items) this.#close(item);
    }

    #toggle(item) {
      if (item.hasAttribute('data-open')) this.#close(item);
      else this.#open(item);
    }

    #hoverOpen(event, item) {
      if (event.pointerType !== 'mouse') return;
      if (!item.hasAttribute('data-open')) this.#hoverOpened = item;
      this.#open(item);
    }

    #hoverClose(event, item) {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(this.#closeTimer);
      this.#closeTimer = setTimeout(() => this.#close(item), 150);
    }

    #syncScrolled() {
      this.header.toggleAttribute('data-scrolled', window.scrollY > 0);
    }

    /* The header sticks below the announcement bar, whose height changes when its text wraps. */
    #watchAnnouncementBar() {
      this.resizeObserver?.disconnect();
      const bar = document.querySelector('.announcement-bar');
      const root = document.documentElement;
      if (!bar) {
        root.style.setProperty('--announcement-bar-height', '0px');
        return;
      }
      this.resizeObserver = new ResizeObserver(([entry]) => {
        root.style.setProperty('--announcement-bar-height', `${entry.borderBoxSize[0].blockSize}px`);
      });
      this.resizeObserver.observe(bar);
    }

    #setUpDrawer(signal) {
      const drawer = this.querySelector('[data-drawer]');
      const toggle = this.querySelector('[data-drawer-open]');
      if (!drawer || !toggle) return;

      // Backdrop, Escape, the close button and aria-expanded on close: snippets/modal-dialog.liquid.
      toggle.addEventListener(
        'click',
        () => {
          drawer.showModal();
          toggle.setAttribute('aria-expanded', 'true');
        },
        { signal },
      );
      // Widening past the phone layout leaves nothing for the drawer to do.
      window.matchMedia('(min-width: 1024px)').addEventListener(
        'change',
        (event) => {
          if (event.matches && drawer.open) drawer.close();
        },
        { signal },
      );
    }

    #revealBlock(event) {
      const item = this.items.find((candidate) => candidate.contains(event.target));
      if (item) this.#open(item);
    }
  }

  customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    #index = 0;
    #timer;
    #abort = new AbortController();
    #playing = false;
    #inView = true;
    #observer;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal }));

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay === 'true' && !reduced && this.slides.length > 1;
      // Hover and focus hold the slides for as long as they last; the pause button until pressed again.
      for (const type of ['pointerenter', 'focusin']) this.addEventListener(type, () => this.#stop(), { signal });
      for (const type of ['pointerleave', 'focusout']) this.addEventListener(type, () => this.#start(), { signal });

      // Videos play unless the visitor prefers reduced motion, and only while the hero is on screen.
      this.videos = [...this.querySelectorAll('[data-hero-video]')];
      this.pause = this.querySelector('[data-hero-pause]');
      this.pause?.addEventListener('click', () => this.#setPlaying(!this.#playing), { signal });
      if (this.videos.length) {
        this.#observer = new IntersectionObserver(([entry]) => {
          this.#inView = entry.isIntersecting;
          this.#syncVideos();
        });
        this.#observer.observe(this);
      }
      this.#setPlaying(!reduced);

      document.addEventListener(
        'shopify:block:select',
        (event) => {
          const index = this.slides.indexOf(event.target);
          if (index > -1) {
            this.#stop();
            this.show(index);
          }
        },
        { signal },
      );
    }

    disconnectedCallback() {
      this.#stop();
      this.#abort.abort();
      this.#observer?.disconnect();
    }

    #setPlaying(playing) {
      this.#playing = playing;
      if (this.pause) {
        this.pause.toggleAttribute('data-paused', !playing);
        this.pause.setAttribute('aria-label', playing ? this.pause.dataset.pauseLabel : this.pause.dataset.playLabel);
      }
      this.#syncVideos();
      if (playing) this.#start();
      else this.#stop();
    }

    /* Only the current slide's video runs; the rest wait, as do all of them off screen. */
    #syncVideos() {
      this.videos.forEach((video) => {
        const current = this.slides[this.#index]?.contains(video);
        if (this.#playing && this.#inView && current) {
          // A refused play (e.g. a phone's low-power mode) leaves the button offering Play — unless
          // the slides turn on their own, which carry on; the video then shows its first frame.
          video.play().catch(() => {
            if (this.#playing && !this.autoplay) this.#setPlaying(false);
          });
        } else {
          video.pause();
        }
      });
    }

    show(index) {
      this.#index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const hidden = i !== this.#index;
        slide.toggleAttribute('aria-hidden', hidden);
        slide.toggleAttribute('inert', hidden);
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.#index)));
      if (this.videos?.length) this.#syncVideos();
    }

    #start() {
      if (!this.autoplay || !this.#playing) return;
      this.#stop();
      this.#timer = setInterval(() => this.show(this.#index + 1), Number(this.dataset.speed) || 6000);
    }

    #stop() {
      clearInterval(this.#timer);
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointerup', (event) => {
    if (event.pointerType !== 'touch') return;
    const viewport = event.target.closest?.('.logo-marquee__viewport');
    if (!viewport || event.target.closest('a')) return;
    viewport.toggleAttribute('data-paused');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-anchors"] && !Shopify.designMode) return;
  try {
    
  /*
    Hides links whose section isn't on the page, shows the grey band while stuck, and marks the
    link of the last section whose top has passed under the bar. Targets are looked up on every
    pass, so sections the theme editor re-renders (or re-anchors) are picked up.
  */
  class ProductAnchors extends HTMLElement {
    #abort;
    #frame = 0;
    #links = [];

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      this.#links = [...this.querySelectorAll('[data-anchor]')];

      window.addEventListener('scroll', () => this.#schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.#schedule(), { signal });
      // A link the customer just clicked leads; the scroll that follows confirms it.
      this.addEventListener(
        'click',
        (event) => {
          const link = event.target.closest('[data-anchor]');
          if (link) this.#mark(link);
        },
        { signal },
      );
      this.#update();
    }

    disconnectedCallback() {
      this.#abort.abort();
      cancelAnimationFrame(this.#frame);
      this.#frame = 0;
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#update();
      });
    }

    #update() {
      const stickyTop = Number.parseFloat(getComputedStyle(this.parentElement).top) || 0;
      const bar = this.getBoundingClientRect();
      this.toggleAttribute('data-stuck', window.scrollY > 0 && bar.top <= stickyTop + 1);

      const shown = [];
      for (const link of this.#links) {
        const target = document.getElementById(link.dataset.anchor);
        link.parentElement.hidden = !target;
        if (target) shown.push({ link, target });
      }
      this.hidden = shown.length === 0;
      if (!shown.length) return;

      // A small allowance so a section jumped to (which stops exactly at the bar) counts as passed.
      let current = shown[0];
      for (const entry of shown) {
        if (entry.target.getBoundingClientRect().top <= bar.bottom + 8) current = entry;
      }
      // At the end of the page no further section can reach the bar, so the last one is current.
      const atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atEnd) current = shown.at(-1);
      this.#mark(current.link);
    }

    #mark(link) {
      if (link.getAttribute('aria-current') === 'true') return;
      for (const other of this.#links) other.setAttribute('aria-current', String(other === link));
      this.#reveal(link);
    }

    /* On narrow screens the row scrolls sideways; keep the current link in view. */
    #reveal(link) {
      const list = link.closest('.anchors__list');
      if (list.scrollWidth <= list.clientWidth + 1) return;
      const offset = link.getBoundingClientRect().left - list.getBoundingClientRect().left;
      const left = list.scrollLeft + offset - (list.clientWidth - link.offsetWidth) / 2;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  customElements.define('product-anchors', ProductAnchors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-more-features"] && !Shopify.designMode) return;
  try {
    
  /* Arrows step one card at a time and dim at either end; they hide while every card fits. */
  class MoreFeaturesCarousel extends HTMLElement {
    #abort;
    #resize;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      const track = this.querySelector('[data-track]');

      this.addEventListener(
        'click',
        (event) => {
          const arrow = event.target.closest('[data-prev], [data-next]');
          if (!arrow || arrow.getAttribute('aria-disabled') === 'true') return;
          this.#step(arrow.hasAttribute('data-next') ? 1 : -1);
        },
        { signal },
      );
      track.addEventListener('scroll', () => this.#sync(), { passive: true, signal });
      this.#resize = new ResizeObserver(() => this.#sync());
      this.#resize.observe(track);
      this.#sync();
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.#resize?.disconnect();
    }

    #step(direction) {
      const track = this.querySelector('[data-track]');
      const card = track.firstElementChild;
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: reduce ? 'auto' : 'smooth' });
    }

    #sync() {
      const track = this.querySelector('[data-track]');
      const { scrollLeft, scrollWidth, clientWidth } = track;
      this.querySelector('[data-nav]').hidden = scrollWidth <= clientWidth + 1;
      this.querySelector('[data-prev]').setAttribute('aria-disabled', String(scrollLeft <= 1));
      this.querySelector('[data-next]').setAttribute(
        'aria-disabled',
        String(scrollLeft + clientWidth >= scrollWidth - 1),
      );
    }
  }

  customElements.define('more-features-carousel', MoreFeaturesCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  /*
    Wires the theme's controls to the Judge.me widget, which renders itself (and re-renders on
    every filter, search and page) after this element connects. The widget is only ever driven
    through its own controls, so its state stays its own.
  */
  class ProductReviews extends HTMLElement {
    #abort;
    #observer;
    #frame = 0;
    #fallbackTimer = 0;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.querySelector('[data-reviews-rating]')?.addEventListener(
        'change',
        (event) => this.#filter(event.target.value),
        { signal },
      );
      this.querySelector('[data-reviews-search]')?.addEventListener('click', () => this.#search(), { signal });
      for (const tile of this.querySelectorAll('[data-rate]')) {
        tile.addEventListener('click', () => this.#write(Number(tile.dataset.rate)), { signal });
      }

      this.#observer = new MutationObserver(() => this.#schedule());
      this.#observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      this.#schedule();

      // Until the widget mounts, a skeleton stands in and the served copies of the reviews stay
      // hidden. If it still hasn't a few seconds after the page has loaded (Judge.me set back to
      // its old widget, or its script failing, say), the skeleton gives way to those copies.
      const watch = () => {
        this.#fallbackTimer = setTimeout(() => {
          if (!this.querySelector('.jm-review-widget__header')) this.dataset.fallback = '';
        }, 4000);
      };
      if (document.readyState === 'complete') watch();
      else window.addEventListener('load', watch, { once: true, signal });
    }

    disconnectedCallback() {
      this.#abort?.abort();
      this.#observer?.disconnect();
      cancelAnimationFrame(this.#frame);
      this.#frame = 0;
      clearTimeout(this.#fallbackTimer);
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.#sync();
      });
    }

    /* Brings the theme's parts up to date with whatever the widget has just rendered. */
    #sync() {
      // Each bar's share is already its fill width; the counts beside them give way to it.
      for (const row of this.#rows()) {
        const frequency = row.querySelector('.jm-histogram-row__frequency');
        const share = Number.parseFloat(row.querySelector('.jm-progress-bar__fill')?.style.width);
        if (!frequency || !Number.isFinite(share)) continue;
        const percent = `${Math.round(share)}%`;
        if (frequency.dataset.percent !== percent) frequency.dataset.percent = percent;
      }

      const average = Number.parseFloat(
        this.querySelector('.jm-average-rating-display .jm-cluster > :first-child')?.textContent.replace(',', '.'),
      );
      if (Number.isFinite(average)) {
        const rating = Math.min(Math.max(average, 0), 5);
        const full = String(Math.floor(rating));
        const part = String(Math.round((rating % 1) * 100) / 100);
        if (this.style.getPropertyValue('--reviews-stars-full') !== full)
          this.style.setProperty('--reviews-stars-full', full);
        if (this.style.getPropertyValue('--reviews-stars-part') !== part)
          this.style.setProperty('--reviews-stars-part', part);
      }

      const select = this.querySelector('[data-reviews-rating]');
      const selected = this.#selectedRating();
      if (select && select.value !== selected) select.value = selected;

      // A fifth photo drawn as "More +" says so to screen readers too.
      for (const list of this.querySelectorAll('.jm-review-item > .jm-stack > :has(> :nth-child(6))')) {
        const tile = list.children[4]?.querySelector('.jm-media-thumbnail-list__thumbnail');
        const label = this.dataset.moreLabel?.replace('[count]', String(list.children.length));
        if (tile && label && tile.getAttribute('aria-label') !== label) tile.setAttribute('aria-label', label);
      }
    }

    #rows() {
      return [...this.querySelectorAll('.jm-histogram-row')];
    }

    #row(rating) {
      return this.#rows().find((row) => row.querySelector('.jm-histogram-row__rating')?.textContent.trim() === rating);
    }

    /* The widget checks the rating it is filtered to in its (hidden) filter panel. */
    #selectedRating() {
      return this.querySelector('.jm-rating-filter__tag input:checked')?.value ?? '';
    }

    /* A histogram row filters to its rating, and choosing it again clears the filter. */
    #filter(value) {
      const current = this.#selectedRating();
      if (value === current) return;
      this.#row(value || current)?.click();
    }

    /* The widget searches on Enter in its field. */
    #search() {
      const input = this.querySelector('.jm-search-bar__input');
      if (!input) return;
      input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', code: 'Enter', keyCode: 13, bubbles: true }));
    }

    /*
      Opens the widget's form, then picks the chosen rating on its first page. The form is rendered
      ahead, hidden, so the star is only clicked once the modal is showing.
    */
    #write(rating) {
      const open = this.querySelector('.jm-action-buttons__button');
      if (!open) return;
      open.click();
      const started = performance.now();
      const pick = () => {
        const modal = document.querySelector('.jdgm-write-review-modal');
        const star = modal?.querySelectorAll('.jdgm-write-review-modal__page--review-form-intro .jdgm-star')[
          rating - 1
        ];
        if (star && modal.checkVisibility()) star.click();
        else if (performance.now() - started < 3000) requestAnimationFrame(pick);
      };
      pick();
    }
  }

  if (!customElements.get('product-reviews')) customElements.define('product-reviews', ProductReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
  /*
    The included row is one line at every width. The arrows step a tile at a time and dim at
    either end; while every tile fits they stay hidden and the row stays centred. The same
    overflow test decides whether a third of the next tile peeks in.
  */
  class IncludedCarousel extends HTMLElement {
    #abort;
    #resize;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      const track = this.querySelector('[data-track]');

      this.addEventListener(
        'click',
        (event) => {
          const arrow = event.target.closest('[data-prev], [data-next]');
          if (!arrow || arrow.getAttribute('aria-disabled') === 'true') return;
          this.#step(arrow.hasAttribute('data-next') ? 1 : -1);
        },
        { signal },
      );
      track.addEventListener('scroll', () => this.#sync(), { passive: true, signal });
      this.#resize = new ResizeObserver(() => this.#sync());
      this.#resize.observe(track);
      this.#sync();
    }

    disconnectedCallback() {
      this.#abort.abort();
      this.#resize?.disconnect();
    }

    #step(direction) {
      const track = this.querySelector('[data-track]');
      const tile = track.firstElementChild;
      if (!tile) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * (tile.offsetWidth + gap), behavior: reduce ? 'auto' : 'smooth' });
    }

    #sync() {
      const track = this.querySelector('[data-track]');
      const { scrollLeft, scrollWidth, clientWidth } = track;
      const overflowing = scrollWidth > clientWidth + 1;
      track.classList.toggle('is-overflowing', overflowing);
      this.querySelector('[data-nav]').hidden = !overflowing;
      this.querySelector('[data-prev]').setAttribute('aria-disabled', String(scrollLeft <= 1));
      this.querySelector('[data-next]').setAttribute(
        'aria-disabled',
        String(scrollLeft + clientWidth >= scrollWidth - 1),
      );
    }
  }

  customElements.define('included-carousel', IncludedCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /*
    Quantity steps, copying the promo code, expanding "Pairs well with", and — with several
    variants — keeping the price block and buttons in step with the selected variant.
  */
  class ProductInfo extends HTMLElement {
    #abort;
    #copyTimer;
    #buyFrame = 0;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.addEventListener('click', (event) => this.#onClick(event), { signal });
      this.addEventListener('submit', (event) => this.#onSubmit(event), { signal });
      this.querySelector('[data-variant-select]')?.addEventListener(
        'change',
        (event) => this.#selectVariant(event.target.value),
        { signal },
      );
      const quantity = this.querySelector('[data-quantity]');
      quantity?.addEventListener('change', () => this.#clampQuantity(), { signal });
      quantity?.addEventListener('keydown', (event) => this.#onQuantityKey(event), { signal });
      this.#watchBuyButtons();
    }

    disconnectedCallback() {
      this.#abort.abort();
      clearTimeout(this.#copyTimer);
      cancelAnimationFrame(this.#buyFrame);
      this.#buyFrame = 0;
    }

    /*
      The sticky bar shows once the buy buttons have gone up under the sticky header, not before.
      Checked on scroll rather than with an IntersectionObserver, which says nothing when a fast
      fling (or a jump) carries the buttons from below the viewport to above it in one frame.
    */
    #watchBuyButtons() {
      const bar = this.querySelector('[data-sticky-buy]');
      const buy = this.querySelector('.product__buy');
      if (!bar || !buy) return;
      const header = document.querySelector('.section-header');
      const update = () => {
        this.#buyFrame = 0;
        const top = Math.max(0, header?.getBoundingClientRect().bottom ?? 0);
        const passed = buy.getBoundingClientRect().bottom < top;
        if (passed === bar.hasAttribute('data-visible')) return;
        // Focus would drop to the page when the bar goes inert: hand it to the button it stands in for.
        if (!passed && bar.contains(document.activeElement)) {
          this.querySelector('.product__buttons [data-add-label]')?.focus({ preventScroll: true });
        }
        bar.toggleAttribute('data-visible', passed);
        bar.inert = !passed;
      };
      const schedule = () => {
        if (!this.#buyFrame) this.#buyFrame = requestAnimationFrame(update);
      };
      const { signal } = this.#abort;
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { signal });
      update();
    }

    /*
      Whole numbers from 1 up to what can be bought (the field's max, per variant); anything else
      (empty, 0, 2.5, 99 of 3 left) is put right before it is sent.
    */
    #clampQuantity(value = this.querySelector('[data-quantity]').value) {
      const input = this.querySelector('[data-quantity]');
      const max = Number(input.max) || Infinity;
      const clamped = Math.min(Math.max(1, Math.floor(Number(value)) || 1), Math.max(1, max));
      input.value = clamped;
      return clamped;
    }

    /*
      Buy now: straight to checkout with this product and any ticked accessories only, through a
      cart permalink, rather than adding them to the cart and checking out everything in it.
    */
    #onSubmit(event) {
      if (event.defaultPrevented || !event.submitter?.hasAttribute('data-skip-drawer')) return;
      const data = new FormData(event.target);
      const quantity = this.#clampQuantity();
      // Unticked accessories aren't in the form data, so their numbers can skip.
      const items = [];
      for (const [name, id] of data) {
        const match = name.match(/^items\[(\d+)\]\[id\]$/);
        if (match && id) items.push(`${id}:${match[1] === '0' ? quantity : 1}`);
      }
      if (items.length === 0) return;
      event.preventDefault();
      window.location.assign(`${window.Shopify?.routes?.root ?? '/'}cart/${items.join(',')}`);
    }

    /*
      Enter in the field would submit with the form's first button, Buy now, and leave for
      checkout. It adds to the cart instead, like the button beside it.
    */
    #onQuantityKey(event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.#clampQuantity();
      const add = this.querySelector('[data-add-label]');
      if (add && !add.disabled) add.form.requestSubmit(add);
    }

    #onClick(event) {
      const step = event.target.closest('[data-step]');
      if (step) {
        this.#clampQuantity(this.#clampQuantity() + Number(step.dataset.step));
        return;
      }

      const copy = event.target.closest('[data-copy]');
      if (copy) {
        this.#copy(copy);
        return;
      }

      const toggle = event.target.closest('[data-pairs-toggle]');
      if (toggle) {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        // A ticked accessory stays in view when the list closes, since it will still be added.
        for (const item of this.querySelectorAll('[data-pairs-extra]')) {
          item.hidden = !expanded && !item.querySelector('input')?.checked;
        }
      }
    }

    async #copy(button) {
      const label = button.querySelector('[data-copy-label]');
      const status = this.querySelector('[data-copy-status]');
      clearTimeout(this.#copyTimer);
      try {
        await navigator.clipboard.writeText(button.dataset.copy);
        label.textContent = button.dataset.copied;
        status.textContent = button.dataset.copied;
      } catch {
        // Clipboard blocked (e.g. no permission): select the code so it can be copied by hand.
        label.textContent = button.dataset.copy;
        window.getSelection()?.selectAllChildren(label);
        status.textContent = button.dataset.copyFailed;
      }
      this.#copyTimer = setTimeout(() => {
        label.textContent = button.dataset.copy;
        status.textContent = '';
      }, 2000);
    }

    #selectVariant(id) {
      const template = this.querySelector(`template[data-variant="${id}"]`);
      if (!template) return;
      this.querySelector('[data-price-block]').replaceChildren(template.content.cloneNode(true));
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = template.dataset.price;
      if (template.dataset.media) this.querySelector('product-gallery')?.show(template.dataset.media);
      const quantity = this.querySelector('[data-quantity]');
      if (quantity) {
        if (template.dataset.max.trim()) quantity.max = template.dataset.max.trim();
        else quantity.removeAttribute('max');
        this.#clampQuantity();
      }
      const available = template.dataset.available === 'true';
      for (const button of this.querySelectorAll('[data-purchase]')) {
        button.disabled = !available;
        // Tells the cart drawer to leave the button disabled when a request it started finishes.
        button.toggleAttribute('data-unavailable', !available);
        if (button.dataset.addLabel) {
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldOutLabel;
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url);
    }
  }

  customElements.define('product-info', ProductInfo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe"]) return;
  try {
    
  /* The print button hands the page to the browser; the print styles do the trimming. */
  class RecipePrint extends HTMLElement {
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('[data-print]')) window.print();
        },
        { signal: this.#abort.signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
    }
  }

  customElements.define('recipe-print', RecipePrint);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /*
    Recipes and Blog are one `type=article` search, because Shopify only splits results by
    resource type. Liquid can't see the `tab` parameter, so the browser marks the tab and hides
    the other group; without JavaScript the page simply shows both.
  */
  class SearchTabs extends HTMLElement {
    connectedCallback() {
      // Only the article view has two groups to choose between.
      if (!this.hasAttribute('data-articles')) return;

      const tab = new URLSearchParams(window.location.search).get('tab');
      if (tab !== 'recipes' && tab !== 'blog') return;

      const link = this.querySelector(`[data-tab="${tab}"]`);
      if (link) link.setAttribute('aria-current', 'page');

      const page = this.closest('.search-page');
      for (const group of page.querySelectorAll('[data-search-group]')) {
        group.hidden = group.dataset.searchGroup !== tab;
      }

      // Searching again from here stays on this tab; Liquid can't read it to write it out.
      const form = page.querySelector('.search-page__form');
      if (!form || form.elements.tab) return;
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'tab';
      field.value = tab;
      form.append(field);
    }
  }

  customElements.define('search-tabs', SearchTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-products"] && !Shopify.designMode) return;
  try {
    
  /*
    The track scrolls and snaps on its own; the dots drive it and follow it back, so the state
    stays right whether the reader clicks, swipes or uses the keyboard.
  */
  class SupportProducts extends HTMLElement {
    #abort;
    #frame = 0;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      this.track = this.querySelector('[data-track]');
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.panels = [...this.querySelectorAll('.support-panel')];
      if (!this.track || this.dots.length < 2) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.#go(index), { signal });
        dot.addEventListener(
          'keydown',
          (event) => {
            const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
            if (!step) return;
            event.preventDefault();
            const next = (index + step + this.dots.length) % this.dots.length;
            this.#go(next);
            this.dots[next].focus();
          },
          { signal },
        );
      });

      this.track.addEventListener('scroll', () => this.#schedule(), { passive: true, signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
      cancelAnimationFrame(this.#frame);
      this.#frame = 0;
    }

    #go(index) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.panels[index].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      this.#mark(index);
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        // A panel may be narrower than the track (phones show the next one's edge).
        const step = (this.panels[1]?.offsetLeft ?? this.track.clientWidth) - this.panels[0].offsetLeft || 1;
        this.#mark(Math.min(Math.round(this.track.scrollLeft / step), this.panels.length - 1));
      });
    }

    #mark(index) {
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', String(i === index));
        dot.tabIndex = i === index ? 0 : -1;
      });
    }
  }

  customElements.define('support-products', SupportProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-videos"] && !Shopify.designMode) return;
  try {
    
  /* Swaps the thumbnail for the player on the first press; nothing from YouTube loads before that. */
  class VideoEmbed extends HTMLElement {
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      this.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-play]');
          if (!button || !this.dataset.video) return;
          // A modified click is the customer asking for YouTube itself; leave it alone.
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          this.#play();
        },
        { signal: this.#abort.signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    #play() {
      const frame = document.createElement('iframe');
      // youtube.com rather than youtube-nocookie.com: the no-cookie player never sees a visitor's
      // YouTube sign-in, so when YouTube asks "confirm you're not a bot" (it does for some networks),
      // being signed in couldn't answer it. The player still loads only on this press.
      frame.src = `https://www.youtube.com/embed/${this.dataset.video}?autoplay=1&rel=0`;
      frame.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; web-share';
      frame.allowFullscreen = true;
      frame.title = this.querySelector('.support-video__title')?.textContent ?? '';
      this.querySelector('.support-video__media').replaceChildren(frame);
      // The button that had focus has just been replaced, so hand focus to the player itself.
      frame.tabIndex = -1;
      frame.focus();
    }
  }

  customElements.define('video-embed', VideoEmbed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel extends HTMLElement {
    #abort = new AbortController();
    #frame;

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      if (!this.cards.length) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.active - 1), { signal });
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.active + 1), { signal });
      this.track.addEventListener('scroll', () => this.#queueSync(), { passive: true, signal });
      window.addEventListener('resize', () => this.#queueSync(), { signal });
      document.addEventListener(
        'shopify:block:select',
        (event) => {
          const index = this.cards.indexOf(event.target);
          if (index > -1) this.go(index);
        },
        { signal },
      );

      // Start on the second card, as in the design, so both neighbours show.
      this.go(this.cards.length > 2 ? 1 : 0, 'instant');
    }

    disconnectedCallback() {
      this.#abort.abort();
      cancelAnimationFrame(this.#frame);
    }

    go(index, behavior = 'smooth') {
      const target = this.cards[(index + this.cards.length) % this.cards.length];
      const left = target.offsetLeft - (this.track.clientWidth - target.offsetWidth) / 2;
      this.track.scrollTo({ left, behavior });
      this.#setActive(this.cards.indexOf(target));
    }

    #queueSync() {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#sync());
    }

    /* The active card is the one whose centre is nearest the track's centre. */
    #sync() {
      const centre = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let bestDistance = Infinity;
      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - centre);
        if (distance < bestDistance) [best, bestDistance] = [index, distance];
      });
      this.#setActive(best);
    }

    #setActive(index) {
      this.active = index;
      this.cards.forEach((card, i) => card.toggleAttribute('data-active', i === index));
    }
  }

  customElements.define('testimonial-carousel', TestimonialCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  class VideoBanner extends HTMLElement {
    #abort = new AbortController();

    connectedCallback() {
      // A fresh controller each time: the theme editor moves sections by re-inserting them.
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.dialog = this.querySelector('[data-video-dialog]');
      if (!this.dialog) return;
      this.player = this.querySelector('[data-video-player]');
      this.querySelector('[data-video-open]')?.addEventListener('click', () => this.open(), { signal });
      // Backdrop, Escape and the close button: snippets/modal-dialog.liquid. However the dialog
      // closes — a back gesture included — the player goes with it, so nothing keeps playing unseen.
      this.dialog.addEventListener(
        'close',
        () => this.player.querySelectorAll('iframe, video').forEach((node) => node.remove()),
        { signal },
      );
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    /* The player is created on open and removed on close, so nothing loads or keeps playing unseen. */
    open() {
      const embed = this.dataset.embedUrl;
      if (embed) {
        const iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.title = this.dialog.getAttribute('aria-label') || '';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        this.player.replaceChildren(iframe);
      } else {
        const template = this.player.querySelector('template');
        if (template) {
          this.player.append(template.content.cloneNode(true));
          // video_tag mutes anything that autoplays; the visitor asked for this one, so it has sound.
          const video = this.player.querySelector('video');
          if (video) {
            video.muted = false;
            video.play().catch(() => {
              // A browser that still refuses sound plays it muted rather than not at all.
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        }
      }
      this.dialog.showModal();
    }
  }

  customElements.define('video-banner', VideoBanner);

  } catch(e) { console.error(e); }
})();
})();
